import type { C1_FurnitureDefinition, C1_FurnitureRendererProps } from "../../types/C1_FurnitureTypes";
import { RoomType } from "../../types/C1_ModelTypes";
import { C1_FurnitureSvg } from "../C1_FurnitureSvg";
import { C1_FurnitureIcon } from "../C1_FurnitureIcon";

const DEFAULT_WIDTH = 1.4;
const DEFAULT_HEIGHT = 0.3;

const Television: C1_FurnitureDefinition = {
  id: "television",
  icon: <C1_FurnitureIcon kind="television" />,
  description: { en: "Flat-screen television", de: "Fernseher" },
  category: RoomType.Living,
  defaultWidth: DEFAULT_WIDTH,
  defaultHeight: DEFAULT_HEIGHT,
  grabsW: true,
  originXPercentage: 50,
  originYPercentage: 0,
  autoRotate: true,
  properties: [],
  Renderer: ({
    width,
    height,
    rotation,
    PX,
    strokeWidth,
    strokeColor,
    fillColor,
    showDetails,
  }: C1_FurnitureRendererProps) => {
    const finalRotation = rotation ?? 0;
    const finalStrokeWidth = strokeWidth ?? 2;
    const finalStrokeColor = strokeColor ?? "#000000";
    const finalFillColor = fillColor ?? "#ffffff";
    const inset = 0.02 * PX;

    return (
      <C1_FurnitureSvg
        PX={PX}
        width={width}
        height={height}
        rotation={finalRotation}
        viewBoxWidth={width}
        viewBoxHeight={height}
        originXPercentage={50}
        originYPercentage={0}
      >
        <rect
          x={inset}
          y={inset}
          width={Math.max(0, width - inset * 2)}
          height={Math.max(0, height - inset * 2)}
          rx={inset}
          fill={finalFillColor}
          stroke={finalStrokeColor}
          strokeWidth={finalStrokeWidth * 2}
        />
        {showDetails && (
          <line x1={width / 2} y1={Math.max(0, height - inset)} x2={width / 2} y2={height} stroke={finalStrokeColor} strokeWidth={finalStrokeWidth * 2} />
        )}
      </C1_FurnitureSvg>
    );
  },
};

export default Television;
